import React, { useEffect, useState } from "react";
import SimpleTextBox from "components/FormElements/SimpleTextBox";
import SimpleTextArea from "components/FormElements/SimpleTextArea";
import Button from "components/FormElements/Button";
import { useTranslation } from "next-i18next";
import PhoneSelectBox from "../FormElements/PhoneSelectBox";
import { useConfigureSelectBoxItem } from "hooks";
import { getCountry, sendMail } from "services/allServices";
import PrivacyPolicy from "../PrivacyPolicy";
import { alertToast, successToast } from "../Toast/AllToast";

function DidntFindForm({ iys, eposta }) {
  const { t } = useTranslation(["common", "iys", "email"]);

  const [phoneList, setPhoneList] = useConfigureSelectBoxItem();
  const [selectedPhone, setSelectedPhone] = useState();
  const [isPrivacyPolicy, setIsPrivacyPolicy] = useState(false)

  const [name, setName] = useState("")
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("")
  const [contents, setContents] = useState("")


  const onSendMail = () => {
    if (!isPrivacyPolicy) {
      return alertToast(t('common:error'), t("common:privacyPolicyError"));
    }

    if (name === "" || phone === "" || email === "" || contents === "") {
      return alertToast(t('common:error'), t("common:fillAllFieldsError"));
    }

    let configure = {
      form_name: "Sunucu İstek Formu",
      name: name,
      phone: phone,
      email: email,
      subject: "",
      contents: contents
    }

    sendMail(configure).then(res => {
      if (res.status === "submitted") {
        successToast(t('common:success'), t("common:mailSendSuccess"))
        setName("")
        setPhone("")
        setEmail("")
        setSubject("")
        setContents("")
      }
    })
  };

  const onGetCountry = async () => {
    let countries = [];
    countries = await getCountry();
    setPhoneList(countries, "phone_code", "country_name");
  };

  useEffect(() => {
    phoneList.map(item => {
      if (item.id === "90") {
        setSelectedPhone(item);
      }
    });
  }, [phoneList]);

  useEffect(() => {
    onGetCountry();
  }, []);
  return (
    <div className="w-full bg-didntFindBg">
      <div className="container px-4 mx-auto lg:px-0">
        <div className="grid grid-cols-2 my-20">
          <div className="flex items-center justify-center col-span-2 lg:col-span-1 ">
            <div className="">
              {!eposta && <p className="mb-2 text-2xl text-selectboxText">{iys ? t('iys:didntFindFormTitleIYS') : t('common:didntFindFormTitle')}</p>}

              {!eposta && <span
                className="relative mb-8 text-4xl font-semibold text-after-shadow lg:text-5xl">{iys ? t("iys:didntFindFormTitle2IYS") : t('common:didntFindFormTitle2')}</span>}
              {eposta && <span className="relative mb-8 text-4xl font-semibold text-after-shadow lg:text-5xl">
                {t('email:emailFormTitle')}
              </span>}
              {!eposta && <p className="mt-5 text-md text-selectboxText lg:pr-48">{iys ? t("iys:didntFindFormDescriptionIYS") : t('common:didntFindFormDescription')}</p>}
              {eposta && <p className="mt-5 text-md text-selectboxText lg:pr-48">{t("email:emailFormDesc")}</p>}
            </div>
          </div>
          <div className="flex justify-center col-span-2 mt-10 lg:col-span-1 lg:mt-0">
            <div className="p-10 bg-white rounded-md shadow-lg lg:w-10/12">
              {!eposta && <h3 className="mb-5 text-2xl font-medium text-selectboxText">{iys ? t("iys:iysRequestForm") : t('common:serverRequestForm')}</h3>}
              {eposta && <h3 className="mb-5 text-2xl font-medium text-selectboxText">{t("email:emailFormTitle2")}</h3>}
              <div className="mb-3">
                <SimpleTextBox
                  value={name} onChange={setName}
                  labelName={t('common:nameSurname')} inputName="name" placeholder={t('common:nameSurname')} />
              </div>
              <div className="mb-3">
                <SimpleTextBox
                  value={email} onChange={setEmail}
                  labelName={t('common:emailAddress')} inputName="eMail" placeholder="info@makdos.com" />
              </div>
              <div className="flex items-center w-full lg:mb-3">
                <div>
                  {selectedPhone &&
                    <PhoneSelectBox data={phoneList} selectedItem={selectedPhone}
                      setSelectedItem={(v) => setSelectedPhone(v)} labelName={t("common:code")} />
                  }
                </div>
                <div className="-mt-3 lg:mt-0.5 w-full relative">
                  <SimpleTextBox value={phone} onChange={(v) => { setPhone(v?.replaceAll(/\D/g, '')) }}
                    labelName={t("common:phoneNumber")} inputName="phone" placeholder="8503077744" />
                </div>
              </div>
              <div className="mb-3">
                <SimpleTextArea
                  value={contents} onChange={setContents}
                  labelName={t('common:yourMessage')} inputName="message" rows="4"
                  placeholder={t('common:didntFindFormPlaceholder')} />
              </div>
              <div className="items-center justify-between mt-5 lg:flex">
                <PrivacyPolicy isPrivacyPolicy={isPrivacyPolicy} setIsPrivacyPolicy={setIsPrivacyPolicy} />
                <div className="lg:w-[350px]">
                  <Button onClick={onSendMail} name="didntFind" buttonText={t('common:requestAQuote')} buttonRightIcon="ri-arrow-right-line" />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default DidntFindForm;
